import React from 'react';
import { Link } from 'react-router-dom';
import { BreadcrumbData } from '../../useProductAnalysis.logic';
import './BreadcrumbSection.styles.scss';

interface BreadcrumbSectionProps {
  breadcrumbData: BreadcrumbData;
}

const BreadcrumbSection: React.FC<BreadcrumbSectionProps> = ({ breadcrumbData }) => {
  return (
    <nav className="product-analysis-breadcrumb">
      <div className="container">
        {breadcrumbData.items.map((item, index) => (
          <React.Fragment key={index}>
            {item.href ? <Link to={item.href}>{item.label}</Link> : <strong>{item.label}</strong>}
            {index < breadcrumbData.items.length - 1 && <span> {'>'} </span>}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default BreadcrumbSection;
